'use client';

import type { ComponentProps } from 'react';

import { useAffiliate } from './AffiliateProvider';
import { Link as BaseLink } from '@/lib/navigation-base';
import { withRef } from '@/lib/ref-param';

/** next-intl Link that keeps `?ref` across internal navigation — the only carrier, no storage. */
export function CarryRefLink(props: ComponentProps<typeof BaseLink>) {
    const { refCode } = useAffiliate();
    return <BaseLink {...props} href={withRef(props.href as never, refCode)} />;
}
